import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MxMaterialModule} from '../../material/mx-material.module';
import {MxButtonModule} from '../mx-button/mx-button.module';
import {MxSharedModule} from '../../shared/mx-shared.module';
import {MxThumbnailComponent} from './mx-thumbnail/mx-thumbnail.component';
import {MxThumbnailEditComponent} from './mx-thumbnail-edit/mx-thumbnail-edit.component';

@NgModule({
  imports: [
    CommonModule,
    MxButtonModule,
    MxMaterialModule,
    MxSharedModule
  ],
  exports: [
    MxThumbnailComponent,
    MxThumbnailEditComponent
  ],
  declarations: [
    MxThumbnailComponent,
    MxThumbnailEditComponent]
})
export class MxThumbnailModule {
}
